


































































































































































































































































































































































































































































































































import Vue from 'vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import { Name } from '@/models/name';
import { Sponsor } from '@/models/sponsor';
import { truncate, isPlainObject, clone } from 'lodash';
import { isEmptyObject } from '@/utils/helpers';

type SnackOptions = {
  msg?: string;
  color?: string;
  href?: string;
  text?: string;
  btnText?: boolean;
  to?: any;
  timeout?: number;
  top?: boolean;
  right?: boolean;
  bottom?: boolean;
  left?: boolean;
  icon?: string;
  action?: Function;
};

export default Vue.extend({
  name: 'SponsorDetail',
  props: ['sponsorId'],
  metaInfo() {
    return {
      title: 'Sponsor'
    };
  },
  data: () => ({
    clonedData: {} as any,
    speakerInstance: {} as Sponsor,
    sponsorError: false,
    tab: 0,
    snackColor: '',
    snackText: '',
    lorem:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
  }),
  computed: {
    ...mapGetters({
      getSponsorById: 'sponsors/getSponsorById'
    }),
    ...mapState({
      sponsorsOptions: (state: any) => state.sponsors.sponsorsOptions,
      categories: (state: any) => state.sponsors.categories,
      sponsorsLoading: (state: any) => state.sponsors.sponsorsLoading
    }),
    id(): number {
      return Number(this.sponsorId);
    },
    queryKey(): number {
      return Number(this.$route.query.tab);
    },
    currentSponsor() {
      return this.getSponsorById(this.id);
    }
  },
  methods: {
    isEmptyObject,
    truncate,

    ...mapActions({
      fetchSponsor: 'sponsors/fetchSponsor',
      deleteSponsor: 'sponsors/deleteSponsor',
      updateSponsor: 'sponsors/updateSponsor',
      optionsSponsor: 'sponsors/optionsSponsor',
      fetchCategories: 'sponsors/fetchCategories',
      clearError: 'sponsors/clearError',
      createSnack: 'snackbar/createSnack'
    }),
    setForm(payload: any) {
      const data = new FormData();
      function iterate(payload: any) {
        for (const key in payload) {
          const value = payload[key];
          console.log({ key, value });

          if (isPlainObject(value)) {
            let keyName;
            for (const nestedKey in value) {
              keyName = [key, '.', nestedKey].join('');
              data.append(keyName, value[nestedKey]);
            }
          } else if (value != null) {
            data.append(key, value);
          }
        }
      }
      iterate(payload);
      console.log(data.values);

      console.log(data.keys);

      return data;
    },
    openEdit() {
      const resourceEdit = (this as any).$refs.resourceEdit;
      resourceEdit.open(clone(this.currentSponsor));
    },
    saveSponsor(sponsor: Sponsor) {
      console.log({ sponsor });

      const data = this.setForm(sponsor);
      console.log({ data });

      return this.updateSponsor({ data: data, id: sponsor.id })
        .then(() => {
          console.log('success');
        })
        .catch(err => {
          console.log('err', err.message);
        });
    },
    getSponsorInitials(name: string) {
      return (
        name.substring(0, 1).toUpperCase() + name.substring(0, 1).toUpperCase()
      );
    },
    async setSponsor() {
      console.log(this.currentSponsor);

      if (!this.currentSponsor) {
        await this.fetchSponsor(this.id).catch(() => {
          this.sponsorError = true;
        });
      }
    },

    cancel() {},
    open() {
      console.log(this.categories);
    },
    close() {},
    async patchSponsor(sponsor: Sponsor) {
      const data = {
        ...sponsor,
        id: this.currentSponsor.id,
        event: this.currentSponsor.event
      };
      console.log({ data });

      await this.updateSponsor({ id: this.currentSponsor.id, data })
        .then(() => {
          this.createSnack({ msg: 'Sponsor Updated', btnText: true });
        })
        .catch(() => {
          this.createSnack({
            msg: 'Failed to Upate sponsor',
            color: 'error',
            btnText: true
          });
        });
    },
    async destroySponsor(id: number) {
      const confirmDialog = this.$refs.confirmDialog as any;
      if (
        await confirmDialog.open('Delete Sponsor?', {
          left: {
            text: 'Cancel'
          },
          right: {
            color: 'error',
            text: 'Delete',
            icon: 'mdi-delete',
            iconOnly: false
          }
        })
      ) {
        this.deleteSponsor(id)
          .then(() => {
            this.createSnack({ msg: 'Sponsor Deleted', btnText: true });
            window.requestAnimationFrame(() => {
              this.$router.push({ name: 'sponsor-list' });
            });
          })
          .catch(() => {
            this.createSnack({
              msg: 'Failed to deleted sponsor',
              color: 'error',
              btnText: true
            });
          });
      } else {
        return;
      }
    }
  },
  watch: {
    $route: 'setSponsor'
  },
  async mounted() {
    await this.$nextTick();
    await this.setSponsor();
    if (this.queryKey) {
      this.tab = this.queryKey;
    }
  }
});
